module.exports = __webpack_public_path__ + "img/Apt.b426ae31.svg";